import React from 'react';
import { motion } from 'framer-motion';

const SkillBar = ({ skill, level, color }) => {
  const barWidth = `${level}%`;
  return (
    <div className="mb-4">
      <div className="flex justify-between mb-1">
        <span className="font-semibold">{skill}</span>
        <span>{level}%</span>
      </div>
      <div className="h-3 bg-gray-700 rounded-full">
        <motion.div
          className="h-full rounded-full"
          style={{ backgroundColor: color }}
          initial={{ width: 0 }}
          whileInView={{ width: barWidth }}
          transition={{ duration: 1, ease: "easeOut" }}
        />
      </div>
    </div>
  );
};

export default SkillBar;
